import React, { useRef, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import ReactMarkdown from "react-markdown";
import { useDebounceCallback } from "@react-hook/debounce";
import { connect } from "react-redux";
// import styled from "styled-components";
import { isEmpty, clone } from "ramda";
import {
  Content,
  ContentBlock,
  MultiValueForm
} from "@onelogin/react-components";
import FormField from "./FormField";
import ProtectedSubmit from "./ProtectedSubmit";
import LargeButton from "./LargeButton";
import {
  sendSupportRequest,
  closeSupportWindow
} from "../actions/supportActions";

const SupportRequest = ({ support, requestSupport, close, intl }) => {
  const formRef = useRef();
  const [disabled, setDisabled] = useState(true);
  const checkDisabled = useDebounceCallback(() => {
    const formState = formRef.current.state;
    setDisabled(
      isEmpty(formState.userEmail.value) ||
        isEmpty(formState.supportRequest.value)
    );
  }, 250);

  const instructions = support.instructions;

  const onSubmit = grecaptchaToken => {
    const { userEmail, supportRequest } = clone(formRef.current.state);
    requestSupport({
      userEmail: userEmail.value,
      supportRequest: supportRequest.value,
      grecaptchaToken
    });
  };

  return (
    <MultiValueForm
      ref={formRef}
      fieldNames={["userEmail", "supportRequest"]}
      onSubmit={() => {}} // Not using the MultiValueForm's submit because it can't be called programatically
      render={fields => (
        <Content data-testid="support-request-form">
          {instructions &&
            <ContentBlock>
              <ReactMarkdown>{instructions}</ReactMarkdown>
            </ContentBlock>
          }

          <FormField
            fieldId="user-email"
            fieldLabel={intl.formatMessage({
              id: "yourEmail",
              defaultMessage: "Your Email"
            })}
            onChange={e => {
              fields.userEmail.onChange(e.target.value);
              checkDisabled();
            }}
            value={fields.userEmail.value}
          />

          <FormField
            fieldId="support-request"
            fieldLabel={intl.formatMessage({
              id: "describeYourIssue",
              defaultMessage: "Describe Your Issue"
            })}
            onChange={e => {
              fields.supportRequest.onChange(e.target.value);
              checkDisabled();
            }}
            value={fields.supportRequest.value}
          />

          <ContentBlock>
            <ProtectedSubmit
              renderButton={({ token }) => (
                <LargeButton
                  onClick={() => onSubmit(token)}
                  size="large"
                  look="primary"
                  disabled={disabled}
                >
                  <FormattedMessage id="submit" defaultMessage="Submit" />
                </LargeButton>
              )}
            />
            <ContentBlock></ContentBlock>
            <LargeButton onClick={close} size="large" look="regular">
              <FormattedMessage id="cancel" defaultMessage="Cancel" />
            </LargeButton>
          </ContentBlock>
        </Content>
      )}
    />
  );
};

const mapStateToProps = state => ({
  support: state.branding.data.support
});

const mapDispatchToProps = dispatch => ({
  requestSupport: request => dispatch(sendSupportRequest(request)),
  close: () => dispatch(closeSupportWindow())
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SupportRequest)
);
